import React, { useEffect, useMemo, useState } from "react";
import { APIKey, FormSections, ProgramContainer } from "../../entities/formTemplateDataType";
import FormValidationUtils from "../../utilities/FormValidationUtils";
import axios from "axios";
import DataUtils, { sanitizeString, saveToBxpFormApi } from "../../utilities/DataUtils";
import ReCaptchaV3 from "../captcha/CaptchComponent";
import ReCaptchaButton from "../captcha/captcha-button";
// import { gaPageview } from '../../utilities/GAUtils';
import { hasHandler, handleResponse } from "../../response/HandleResponseService";
import { setBaseHeaders } from "../../utilities/submitUtils";
import {generateAndDownloadPDF, generateBase64PdfTemplate, generateHtmlForPdf} from "../../services/PDFGenerationService";
import {DetailFormComponent} from "../../designComponent/DetailFormComponent";
import URLUtils from "../../utilities/URLUtils";
import SessionStorageService from "../../services/SessionStorageService";
import {TOKEN_TYPE} from "../../entities/Constants";
import { generateReviewHtml } from "../../utilities/ReviewHtmlUtils";
import SectionUtils from "../../utilities/SectionUtils";
import { getEnvVar } from "../../config/RuntimeConfig";


interface Props {
    token: string;
    programContainer: ProgramContainer;
    isEng: boolean;
    section: FormSections;
    onButtonClick: (data) => void; // Callback function type
    callbackStepIndex?: (index: number, returnIndex?: number) => void;
    sumStyle?: string;
}

const HandleSubmitComponent: React.FC<Props> = ({ programContainer, isEng, section, onButtonClick, callbackStepIndex, sumStyle}) => {
    const [validationErrMsg, setValidationErrMsg] = useState<any[]>([]);
    const [isBusy, setIsBusy] = useState<boolean>(false);
    const [confirmationVisible, setConfirmationVisible] = useState<boolean>(false);
    const [summaryVisible, setSummaryVisible] = useState<boolean>(true);
    const [transactionId, setTransactionId] = useState<string>('');
    const [uploadReceiptSuccess, setUploadReceiptSuccess] = useState<boolean>(false);
    const [submissionError, setSubmissionError] = useState<boolean>(false);
    const cleanupAfterSubmit = () => {
        if (!programContainer.ClearFormAfterSubmit) {
            return;
        }
        DataUtils.clearFormValue(programContainer);
        SectionUtils.resetDirtyFlags(programContainer);
    };

    const handleSubmitNoRecaptha = () => {
        handleSubmit(null);
    }
    const handleSubmit = async (token: string) => {
        const invalidControlList = FormValidationUtils.invalidControls(section);
        if (invalidControlList.length > 0) {
            setValidationErrMsg(invalidControlList);
             window.scrollTo(0, 0);
            const errorContainer = document.getElementById('error-container');
            if (errorContainer) {
                errorContainer.focus();
            }
        } else {
     
            if (programContainer.AuthRequired === "tk") {
                const htmlStr = generateReviewHtml({
                  programContainer,
                  isEng,
                  forDownload: true,
                  forceShow: true,
                  showReview: true,
              });     

              const ret = await DataUtils.saveToServer(true,programContainer,  isEng, htmlStr, null,null );
              if(!ret){
                alert('Error happened during submission. Please try again later.');
              }
              return;
            }

            if(programContainer.APIBasePath){
                programContainer.UpdateAPI = `${programContainer.APIBasePath}${programContainer.UpdateAPI}`;
            }
            let url = programContainer.UpdateAPI;
            const data = DataUtils.collectFormValue(programContainer);
            const updateToken =
                SessionStorageService.getAuthToken(programContainer.AuthRequired) ||
                programContainer.Profile?.token;
            const apiKey: APIKey = (programContainer.ApiKeyKey && programContainer.ApiKeyValue) ? {key: programContainer.ApiKeyKey, value: programContainer.ApiKeyValue} : null;
            let headers = setBaseHeaders('application/json', updateToken, apiKey);
            if(programContainer.AuthRequired=='ad'){
                const adToken = SessionStorageService.getAccessToken(TOKEN_TYPE.API);
                if(adToken){
                    headers = setBaseHeaders('application/json', adToken, apiKey);
                }   
            }
            const payload = {
                "language": isEng ? "EN" : "FR",
                "userId": programContainer.Profile?.userId,
                "email": programContainer.AuthRequired=='ad'? SessionStorageService.getUserId():  programContainer.Profile?.email,
                firstName: programContainer.Profile?.firstName,
                lastName: programContainer.Profile?.lastName,

                ...data
            };

            if (getEnvVar('DISABLED_RECAPTCHA') == "false") {
                payload["token"] = token;
            }

            setIsBusy(true);

            axios.post(url, payload, { headers: headers })
                .then(res => {
                    console.log(res);
                    if (hasHandler(programContainer.CategoryId)) {
                        const result = handleResponse(programContainer.CategoryId, res.data, section);
                        if (result?.processSuccessful) {
                            callbackStepIndex(result.stepIndex);
                            return;
                        }
                    } else {
                        console.log('No API response handler found for: ', programContainer.CategoryId);
                        let currentEntity = res.data?.WebResponse;
                        if (currentEntity?.statusCode == 3) {
                            callbackStepIndex(8);
                            return;
                        }
                    }
                    setIsBusy(false);
                    setConfirmationVisible(true);
                    setSummaryVisible(false);
                    setTransactionId(res.data.WebResponse?.transactionId);
                    window.scrollTo(0, 0);
                    setUploadReceiptSuccess(res.data.WebResponse?.uploadReceiptSuccess);
                    DataUtils.clearDraft(
                        programContainer.CategoryId,
                        programContainer.Profile?.email,
                        programContainer.draftId
                    );
                    programContainer.draftId = undefined;
                    cleanupAfterSubmit();
                    const title={title:'Submit'};
                    // gaPageview(title)
                })
                .catch(err => {
                    setIsBusy(false);
                    setSummaryVisible(false);
                    // If the API returned 409 (duplicate/conflict), show the error message instead of generic tech error
                    if (err?.response?.status === 409 && err?.response?.data) {
                        const errorMsg = typeof err.response.data === 'string'
                            ? err.response.data
                            : err.response.data.messageEn || err.response.data.message || JSON.stringify(err.response.data);
                        const errorMsgFr = typeof err.response.data === 'string'
                            ? err.response.data
                            : err.response.data.messageFr || errorMsg;
                        setSummaryVisible(true);
                        setValidationErrMsg([{
                            ErrorMessage: errorMsg,
                            ErrorMessageFRA: errorMsgFr,
                            EmptyErrorMessage: errorMsg,
                            EmptyErrorMessageFRA: errorMsgFr,
                            Visible: true,
                            Valid: false,
                            Disabled: false
                        }]);
                        window.scrollTo(0, 0);
                        console.log('Duplicate submission detected (409):', errorMsg);
                        return;
                    }
                    setSubmissionError(true);
                    console.log(err);
                });
        }
    };

    // option for eComplaint
    const sendAsEmail = async () => {
        setIsBusy(true);
        console.log('send as email');
 
        // note: hardcoded for eComplaint form -- change property name (lisAttachments) to binding name of attachment field
        const payload = DataUtils.collectFormValue(programContainer);
        const listOfAttachments = payload.lisAttachments;
        let base64Attachments = null;
        let attachmentPaths = null;
        if (listOfAttachments) {
            base64Attachments = listOfAttachments.map(item => item.attachment);
            //console.log(base64Attachments);
            attachmentPaths = listOfAttachments.map(item => item.path);
        }
 
        const emailRequest = {
            from: programContainer.EmailSender,
            multipleTo: programContainer.EmailRecipients,
            subject: programContainer.EmailSubject,
            content: programContainer.EmailBody,
            pdf: await generateBase64PdfTemplate(programContainer, isEng? 'en' : 'fr'),
            xml: DetailFormComponent.generateXML(payload),
            attachments: base64Attachments,
            attachmentNames: attachmentPaths,
        };
 
        try {
            let api = URLUtils.concatUrls("data/email/send-email");
            const token = SessionStorageService.getAccessToken(TOKEN_TYPE.API);
            let headers = {};
               if (token!=null) {
                headers = {
                    'Authorization': `Bearer ${token}`,
                }
            }
            if (programContainer.ApiKeyKey && programContainer.ApiKeyValue) {
                headers = {
                    ...headers,
                    [programContainer.ApiKeyKey]: programContainer.ApiKeyValue,
                };
            }
 
             const axiosConfig = Object.keys(headers).length ? { headers } : undefined;
             const response = await axios.post(api, emailRequest, axiosConfig);  
            // const response = await axios.post(api, emailRequest, { headers: headers });
            setIsBusy(false);
            setConfirmationVisible(true);
            setSummaryVisible(false);
            window.scrollTo(0, 0);
            DataUtils.clearDraft(
                programContainer.CategoryId,
                programContainer.Profile?.email,
                programContainer.draftId
            );
            programContainer.draftId = undefined;
            cleanupAfterSubmit();
            console.log("Request was sent successfully.", response.data.message);

        } catch (error) {
            console.error("Error encountered.", error.response?.data?.message || error.message);
            setIsBusy(false);
            setSummaryVisible(false);
            setSubmissionError(true);
        }
    }

    const props = useMemo(() => ({
        isBusy,
        confirmationVisible,
        summaryVisible,
        transactionId,
        uploadReceiptSuccess,
        submissionError,
        validationErrMsg
    }), [isBusy, validationErrMsg]);

    useEffect(() => {
        onButtonClick(props);
    }, [props]);

    return (
        <div style={{ marginTop: '0px', display: 'flex', alignItems: 'stretch', float: "right" }}>
            <div className="ontario-margin-top-24-!">
                {/* Download button for default summary page*/}
                { sumStyle === 'Default' && (
                    <button className="ontario-button ontario-button--secondary"
                        onClick={(e) => {
                            if (isEng && programContainer.pdfTemplate) {
                                generateAndDownloadPDF(programContainer, 'en');
                            } else if (!isEng && programContainer.pdfTemplateFRA) {
                                generateAndDownloadPDF(programContainer, 'fr');
                            }
                        }}>
                        {isEng ? "Download PDF" : "Télécharger le PDF"}
                    </button>
                )}

                {/* Submit button */}
                { programContainer.EmailCopy ? (
                    // Email submission
                    <button
                    className="ontario-button ontario-button--primary"
                    onClick={sendAsEmail}
                    >
                    {isEng ? "Submit" : "Envoyer"}
                    </button>
                ) : (
                    <>
                        {(() => {
                        // Determine the submit button label:
                        // - If KeepContinueButtonLeft is true & NextButtonLabel is not empty, use the specified label
                        // - Otherwise, fall back to default 'Submit' label
                        const submitLabel = section.KeepContinueButtonLeft ? (isEng ? section.NextButtonLabel : section.NextButtonLabelFRA) : (isEng ? 'Submit' : 'Soumettre'); 
                        return getEnvVar('DISABLED_RECAPTCHA') == 'false' ? (
                            <ReCaptchaV3 lang={isEng ? 'en' : 'fr'}>
                                <ReCaptchaButton id={`recaptchbutton-${Math.round(Math.random()*1000)}`}
                                    title={submitLabel}
                                    action='submitAPP'
                                    buttonHandler={handleSubmit}>
                                    {submitLabel}
                                </ReCaptchaButton>
                            </ReCaptchaV3>
                        ) : (
                            <button onClick={handleSubmitNoRecaptha} className="ontario-button ontario-button--primary" >
                                {isEng ? 'Submit' : 'Soumettre'}
                            </button>
                        );
                    })()}
                    </>
                )}
            </div>
        </div>
    );
};

export default HandleSubmitComponent;
